import React from 'react';
import NumberFormat from 'react-number-format';

const CustomerDetailsCard = React.memo(function CustomerDetailsCard({ state, onChange, errors, customerType }) {
  return (
    <div className="rx-card">
      <div className="rx-card-line rx-cl-blue" />
      <div className="rx-card-hd">
        <span className="rx-card-ico rx-ico-blue"><i className="fas fa-user" /></span>
        <span className="rx-card-title">Customer Details 1 &mdash; <i>{customerType}</i></span>
      </div>
      <div className="rx-card-body">
        <div className="rx-cols-2">
          <div className="rx-fg">
            <label>First Name <span className="req">*</span></label>
            <input type="text" className="rx-ff" maxLength={50} value={state.paxFirstName} onChange={onChange} name="paxFirstName" placeholder="Enter first name" />
            {errors.paxFirstName.length > 0 && <span className="rx-err">{errors.paxFirstName}</span>}
          </div>
          <div className="rx-fg">
            <label>Last Name <span className="req">*</span></label>
            <input type="text" className="rx-ff" maxLength={50} value={state.paxLastName} onChange={onChange} name="paxLastName" placeholder="Enter last name" />
            {errors.paxLastName.length > 0 && <span className="rx-err">{errors.paxLastName}</span>}
          </div>
        </div>
        <div className="rx-cols-phone">
          <div className="rx-fg">
            <label>Code</label>
            <input type="text" className="rx-ff" name="countryCodePhone" placeholder="+1" maxLength="2" value={state.countryCodePhone} onChange={onChange} />
          </div>
          <div className="rx-fg">
            <label>Phone</label>
            <NumberFormat className="rx-ff" name="phoneNumber" placeholder="(000) 000-0000" value={state.phoneNumber} onChange={onChange} format="###-###-####" />
          </div>
        </div>
        <div className="rx-cols-phone">
          <div className="rx-fg">
            <label>Code <span className="req">*</span></label>
            <input type="text" className="rx-ff" name="countryCode" placeholder="+1" maxLength="2" value={state.countryCode} onChange={onChange} />
            {errors.countryCode.length > 0 && <span className="rx-err">{errors.countryCode}</span>}
          </div>
          <div className="rx-fg">
            <label>Mobile Number <span className="req">*</span></label>
            <NumberFormat className="rx-ff" name="mobileNumber" placeholder="(000) 000-0000" value={state.mobileNumber} onChange={onChange} format="(###) ###-####" />
            {errors.mobileNumber.length > 0 && <span className="rx-err">{errors.mobileNumber}</span>}
          </div>
        </div>
        <div className="rx-cols-2">
          <div className="rx-fg">
            <label>Email <span className="req">*</span></label>
            <input type="text" className="rx-ff" name="email" placeholder="example@domain.com" maxLength="100" value={state.email} onChange={onChange} />
            {errors.email.length > 0 && <span className="rx-err">{errors.email}</span>}
          </div>
          <div className="rx-fg">
            <label>PO / Client Ref #</label>
            <input type="text" className="rx-ff" name="poNumber" maxLength="100" value={state.poNumber} onChange={onChange} placeholder="PO / Client Ref #" />
          </div>
        </div>
        <div className="rx-cols-3">
          <div className="rx-fg">
            <label>Order By <span className="req">*</span></label>
            <input type="text" className="rx-ff" maxLength={50} value={state.orderByName} onChange={onChange} name="orderByName" placeholder="Order by name" />
            {errors.orderByName.length > 0 && <span className="rx-err">{errors.orderByName}</span>}
          </div>
          <div className="rx-fg">
            <label>Order Phone</label>
            <div style={{ display: 'flex', gap: '4px' }}>
              <input type="text" className="rx-ff" name="countryCodeOrderPhone" placeholder="+1" maxLength="2" style={{ width: '52px', flexShrink: 0 }} value={state.countryCodeOrderPhone} onChange={onChange} />
              <NumberFormat className="rx-ff" name="phoneNumberOrder" placeholder="(000) 000-0000" value={state.phoneNumberOrder} onChange={onChange} format="###-###-####" />
            </div>
          </div>
          <div className="rx-fg">
            <label>Order Email</label>
            <input type="text" className="rx-ff" name="emailOrder" placeholder="example@domain.com" maxLength="100" value={state.emailOrder} onChange={onChange} />
          </div>
        </div>
      </div>
    </div>
  );
});

export default CustomerDetailsCard;
